import {action, computed, makeObservable, observable} from "mobx";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import {default as handleErrorToast} from "../../../components/toast/ErrorToast";
import {default as handleSuccessToast} from "../../../components/toast/SuccessToast";
import taxDocumentForm from "../../../domain/TaxDataForm";
import CustomerOnboardingPanelFeature from "./CustomerOnboardingPanelFeature";

export default class TaxDataPanelFeature extends CustomerOnboardingPanelFeature {

    constructor(application, generalFeature) {
        super(application, generalFeature);
        this._taxDataForm = null;
        this._taxDataSavesInProgress = Promise.resolve();

        makeObservable(this, {
            _taxDataForm: observable,
            taxDataForm: computed,
            editTaxData: action,
        })
    }

    async load() {
        this.createTaxDataForm();
        this.finishLoading();
    }

    createTaxDataForm() {
        this._taxDataForm = taxDocumentForm.newFor(this.customerOnboarding().request.taxData, this, this.customerOnboarding().configuration);
    }

    async formChanged() {
        await this.editTaxData()
    }

    // Uploading or removing a file saves twice (the form change and the field blur); chaining the saves keeps
    // two requests from rewriting the same stored files at the same time.
    editTaxData() {
        const saveTaxData = () => this._saveTaxData();
        this._taxDataSavesInProgress = this._taxDataSavesInProgress.then(saveTaxData, saveTaxData);
        return this._taxDataSavesInProgress;
    }

    async _saveTaxData() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: async (response) => {
                await this.customerOnboardingHasChanged()
                this.createTaxDataForm();
                handleSuccessToast("Datos guardados correctamente.");
            },
            handlesError: (response) => {
                handleErrorToast("No se pudieron guardar los datos");
            }
        });
        return this._application.apiClient().editTaxData(this.customerOnboarding().request.taxpayerIdentificationNumber,
            this._taxDataForm.values, responseHandler);
    }

    needsExemptionsCertificate(){
        return !this.form.isOptional('exemptionsCertificate')
    }

    needsNonWithholdingCertificate(){
        return !this.form.isOptional('nonWithholdingCertificate')
    }

    createForm(){
        return this.createTaxDataForm()
    }

    get form() {
        return this._taxDataForm;
    }

    get taxDataForm() {
        return this._taxDataForm;
    }

    rawIncome(){
        return [
            'Jurisdicción Local',
            'Convenio Multilateral',
            'No Inscripto',
            'No Alcanzado',
            'Consumidor Final',
            'Exento'
        ]
    }

    incomeTax(){
        return [
            'Inscripto',
            'No Inscripto',
            'No Alcanzado',
            'Exento'
        ]
    }

    ivaCondition(){
        return [
            'Responsable Inscripto',
            'Monotributista',
            'Exento/No Alcanzado',
            'Consumidor Final'
        ]
    }

    provincesPerceptions(){
        return [
            'CABA',
            'Misiones',
            'Buenos Aires',
            'Salta',
            'Corrientes',
            'Jujuy',
            'San Luis',
            'La Rioja'
        ]
    }

    yesOrNo(){
        return [
            'Si',
            'No',
        ]
    }

    provincesPerceptionsOptions() {
        return this.optionsFor(this.provincesPerceptions());
    }

    yesOrNoOptions() {
        return this.optionsFor(this.yesOrNo());
    }

    incomeTaxOptions() {
        return this.optionsFor(this.incomeTax());
    }

    ivaConditionOptions() {
        return this.optionsFor(this.ivaCondition());
    }

    rawIncomeOptions() {
        return this.optionsFor(this.rawIncome());
    }

    optionsFor(values) {
        return values.map(value => {
            return {label: value, value: value}
        });
    }
}
